import { simpleSet } from '@r/reducers/utils';

const setCalculationModeShippingCostOptions = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.shippingCost.options;

export const options = setCalculationModeShippingCostOptions(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_SHIPPING_COST_OPTIONS',
  []
);
